import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { classNames } from "../utils";

export interface TabProps {
  identifier: string;
  label: string;
  icon?: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
  href?: string;
  isSelected?: boolean;
  handleClick?: (tab: TabProps) => void;
  noMinWidth?: boolean;
  className?: string;
  fontSize?: string;
  selectedClassName?: string;
  selectedUnderlineClassName?: string;
}
type Props = {
  tabs: TabProps[];
  initial?: string;
  onChange?: (tab: TabProps) => void;
  enabled?: boolean;
};

const Tab = (props: TabProps) => {
  const navigate = useNavigate();
  const defaultFontSize = "text-sm";
  const fontSize = props.fontSize ? props.fontSize : defaultFontSize;
  return (
    <div
      className={classNames(
        "relative flex items-center cursor-pointer py-4",
        fontSize,
        props.isSelected
          ? props.selectedClassName ?? "text-green-600 font-medium"
          : props.className ?? "text-gray-400",
        props.noMinWidth ? "px-2" : "min-w-32"
      )}
      onClick={() => {
        props.handleClick?.(props);
        if (props.href) navigate(props.href);
      }}
    >
      {props.icon ? (
        <props.icon
          aria-hidden="true"
          className={classNames(
            "w-6 h-6 mr-2",
            props.isSelected ? "text-green-600" : "text-gray-400"
          )}
        />
      ) : (
        <></>
      )}
      <span>{props.label ?? "NA"}</span>
      {props.isSelected ? (
        <div
          className={classNames(
            "absolute left-0 bottom-[-1px] h-1 ",
            props.noMinWidth ? "w-full" : "w-32",
            props.selectedUnderlineClassName ?? "bg-green-500"
          )}
        ></div>
      ) : (
        <></>
      )}
    </div>
  );
};
const TabsSelection = ({ tabs, initial, onChange, enabled = true }: Props) => {
  const [selected, setSelected] = useState<string>();

  useEffect(() => {
    setSelected(initial);
  }, [initial]);

  function handleChange(tab: TabProps) {
    setSelected(tab.identifier);
    onChange?.(tab);
  }
  return (
    <div
      className={classNames(
        "flex border-b gap-4",
        !enabled ? "pointer-events-none" : ""
      )}
    >
      {tabs &&
        tabs.map((tab) => (
          <Tab
            key={tab.identifier}
            {...tab}
            isSelected={selected === tab.identifier}
            handleClick={(tab) => {
              if (enabled) handleChange(tab);
            }}
          />
        ))}
    </div>
  );
};

export default TabsSelection;
